import { render, staticRenderFns } from "./FormSecondaryEventBlockGeneralSettings.vue?vue&type=template&id=406c106c"
import script from "./FormSecondaryEventBlockGeneralSettings.vue?vue&type=script&lang=js"
export * from "./FormSecondaryEventBlockGeneralSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports